export const getPaths = ({
  currentUserId,
  topicId,
  ventureId,
}: {
  currentUserId: number;
  topicId: number | null;
  ventureId: number;
}) =>
  topicId
    ? {
        edit: Routes.edit_topic_venture_path(topicId, ventureId),
        index: Routes.topic_ventures_path(topicId),
        show: Routes.topic_venture_path(topicId, ventureId),
        delete: Routes.topics_topic_venture_path(topicId, ventureId),
      }
    : {
        edit: Routes.edit_venture_path(ventureId),
        index: Routes.ventures_path(),
        show: Routes.venture_path(ventureId),
        delete: Routes.user_ventures_venture_path(currentUserId, ventureId),
      };
